import BaseBalanceContainer from 'Engine/containers/ui/BaseBalanceContainer';
import { shadowText } from 'Engine/utils/fontStyles';

export default class BalanceContainer extends BaseBalanceContainer {
  init() {
    super.init();
    this.titleText.style = {...this.titleText.style, ...shadowText}
  }
}
